// extracted by mini-css-extract-plugin
export var wishlist = "WishlistButton-module--wishlist--1BopN";
export var active = "WishlistButton-module--active--xhgY2";